
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppFilterSectionCategoryFilter',
  props: {
    selectedCategory: { type: Number, default: null }
  },
  computed: {
    ...mapState('productCategories', ['isLoadingProductCategories']),
    ...mapGetters('productCategories', ['filterableProductCategories']),
    categoryOptions() {
      return this.filterableProductCategories.map(category => ({
        name: category.name,
        value: category.id
      }));
    }
  },
  created() {
    this.fetchProductCategories();
  },
  methods: {
    ...mapActions('productCategories', ['fetchProductCategories'])
  }
};
